import { StyleBasedFeature } from './styleBased.types'
import { styleBasedDomApplier } from './styleBasedDomApplier'
import { compStyles } from './compStylesCompNode'
import { compTheme, innerElementsStyles, innerElementTheme } from './compThemeCompNode'
import { themeVariants } from './themeVariantsCompNode'
import { viewportSize } from './viewportSizeCompNode'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const styleBasedFeature: StyleBasedFeature = {
	featureName: 'styleBased',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { compTheme: compTheme(false), themeVariants, viewportSize, innerElementTheme },
	intermediateNodes: { compStyles, innerElementsStyles },
	dataMaps: ['theme_data', 'variants_data', 'innerElements'],
	domApplier: styleBasedDomApplier,
}
export const editorStyleBasedFeature: StyleBasedFeature = {
	...styleBasedFeature,
	renderableNodes: {
		...styleBasedFeature.renderableNodes,
		compTheme: compTheme(true),
	},
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(styleBasedFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorStyleBasedFeature)
}
